<template>
  <div class="download">
    <div class="download-content" :style="{height:screenHeight}">
      <div class="content">
        <div>
          <h3>峰学未来APP</h3>
          <p>志愿第一步 峰学来开路</p>
          <div class="qrcode">
            <div class="ios">
              <el-button type="primary" v-if="isIOSClick" @click="showIOSActive" class="iosContent">
                <i class="el-icon-iosClick"></i>
                <span class="icon-text">苹果手机</span>
              </el-button>
              <el-button  @click="showIOSActive" v-else>
                <i class="el-icon-iosNormal"></i>
                <span class="icon-text">苹果手机</span>
              </el-button>
              <div class="code" v-show="isIOSClick">
                <img :src="iosCode"/>
              </div>
            </div>
            <div class="android">
              <el-button @click="showAndroidActive"  v-if="!isAndroidClick" class="androidContent">
                <i class="el-icon-androidNormal"></i>
                <span class="icon-text">安卓手机</span>
              </el-button>
              <el-button type="primary" @click="showAndroidActive"  v-else>
                <i class="el-icon-androidClick"></i>
                <span class="icon-text">安卓手机</span>
              </el-button>
              <div class="code" v-show="isAndroidClick">
                <img :src="androidCode" style="width: 17.5rem;height: 17.5rem;margin: 0.5rem 0.5rem 0.5rem 2.5rem"/>
              </div>
            </div>
          </div>
        </div>
        <img :src="teacherImg">

        <!--<span class="bossName">张雪峰老师</span>-->

      </div>
    </div>
  </div>
</template>

<script>
import iosCode from '@/assets/img/iosCode.png';
/*import androidCode from '@/assets/img/androidCode.png';*/
import teacherImg from '@/assets/img/teacherName.png';
export default {
  name: "download",
  data() {
    return {
      iosCode: iosCode,
      androidCode:'https://oss.fxwljy.com/attach/fxwlAndroidQrCode.png',
      screenHeight: null,
      isIOSClick: true,
      isAndroidClick: false,
      teacherImg:teacherImg
    }
  },
  mounted() {
    this.screenHeight = window.innerHeight + 'px';
  },
  created() {

  },
  methods:{
    showIOSActive(){
      this.isIOSClick = !this.isIOSClick;
      this.isAndroidClick = false
    },
    showAndroidActive(){
      this.isIOSClick = false;
      this.isAndroidClick = !this.isAndroidClick
    }
  }
};
</script>

<style lang="scss" scoped>
@font-face {
  font-family: 'SourceHanSansCN';
  src: url('https://oss.kaoyanvip.cn/attach/file1706509868982.otf');
}
@font-face {
  font-family: 'SourceHanSansCNBold';
  src: url('https://oss.kaoyanvip.cn/attach/file1706509868791.otf');
}
.download{
  width: 100%;
  height: 100%;
  min-width: 1200px;
  overflow: auto;
  .download-content{
    background-image: url("../assets/img/downloadBg.jpg");
    background-size: cover;
    width: 100%;
    max-height: 896px;
    .content{
      display: flex;
      padding-top: 260px;
      margin: 0 auto;
      justify-content: space-between;
      width: 1200px;
      img{
        justify-content: flex-end;
        width: 40px;
        height: 165px;
        margin-top: 280px;
      }
      h3{
        font-size: 60px;
        font-family: 'SourceHanSansCNBold Microsoft YaHei';
        font-weight: bold;
        color: #0A0D0F;
        line-height: 72px;
        letter-spacing: 9px;
      }
      p{
        font-size: 28px;
        font-family: 'SourceHanSansCN Microsoft YaHei';
        font-weight: 400;
        color: #53616D;
        line-height: 30px;
        letter-spacing: 12px;
        margin-top: 30px;
      }
      .bossName{
        position: absolute;
        font-size: 18px;
        font-family: 'SourceHanSansCN Microsoft YaHei';
        font-weight: 400;
        color: #0086FF;
        line-height: 24px;
        writing-mode: vertical-rl;
        letter-spacing: 1px;
        top: 84%;
        right: 160px;
      }
      .qrcode{
        margin-top: 100px;
        position: relative;
      }
      .android{
        margin-top: 24px;
        ::v-deep .el-button--primary{
          padding: 21px 46px;
          background: #0086FF;
          border-radius: 12px;
          font-size: 20px;
          font-family: 'SourceHanSansCN Microsoft YaHei';
          font-weight: 400;
          color: #FFFFFF;
          line-height: 24px;
          border: 1px solid #0086FF;
        }
        ::v-deep .el-icon-androidNormal{
          background: url('../assets/img/android-unclick.png') left no-repeat;			// 注意此处的url，在这里引入自己的图片
          font-size: 26px;
          background-size: contain;
          width: 30px;
          height: 30px;
          margin-right: 8px;
        }
        ::v-deep .el-icon-androidNormal:before {
          content: "替";
          font-size: 26px;
          visibility: hidden;
        }
        ::v-deep .el-icon-androidClick{
          background: url('../assets/img/android-click.png') left no-repeat;			// 注意此处的url，在这里引入自己的图片
          font-size: 26px;
          background-size: contain;
          margin-right: 8px;
          width: 30px;
          height: 30px;
        }
        ::v-deep .el-icon-androidClick:before {
          content: "替";
          font-size: 26px;
          visibility: hidden;
        }
        .icon-text{
          /*padding-top: 5px;*/
        }
        .code {
          background: url("../assets/img/qrcodeAndroid.png") center no-repeat;
          width: 204px;
          height: 184px;
          position: absolute;
          bottom: 0;
          left: 250px;
          background-size: cover;
          border-radius: 12px;
          img{
            width: 165px;
            height: 165px;
            margin: 10px 10px 10px 30px;
          }
        }
      }
      .ios{
        .iosContent:hover{
          padding: 21px 46px;
          background: #0086FF;
          border-radius: 12px;
          font-size: 20px;
          font-family: 'SourceHanSansCN Microsoft YaHei';
          font-weight: 400;
          color: #FFFFFF;
          line-height: 24px;
          border: 1px solid #0086FF;
        }
        ::v-deep .el-button--primary{
          padding: 21px 46px;
          background: #0086FF;
          border-radius: 12px;
          font-size: 20px;
          font-family: 'SourceHanSansCN Microsoft YaHei';
          font-weight: 400;
          color: #FFFFFF;
          line-height: 24px;
          border: 1px solid #0086FF;
        }
        ::v-deep .el-icon-iosClick{
          background: url('../assets/img/ios-click.png') left no-repeat;
          font-size: 26px;
          background-size: contain;
          margin-right: 8px;
          width: 30px;
          height: 30px;
        }
        ::v-deep .el-icon-iosClick:before {
          content: "替";
          font-size: 26px;
          visibility: hidden;
        }
        ::v-deep .el-icon-iosNormal{
          background: url('../assets/img/ios-uncheck.png') left no-repeat;
          font-size: 26px;
          background-size: contain;
          margin-right: 8px;
          width: 30px;
          height: 30px;
        }
        ::v-deep .el-icon-iosNormal:before {
          content: "替";
          font-size: 26px;
          visibility: hidden;
        }
        .code{
          background: url("../assets/img/qrcodeIos.png") center no-repeat;
          width: 204px;
          height: 184px;
          position: absolute;
          top: 0;
          left: 250px;
          background-size: cover;
          border-radius: 12px;
          img{
            width: 165px;
            height: 165px;
            margin: 10px 10px 10px 30px;
          }
        }
      }
      ::v-deep .el-button{
        border-radius: 12px;
        border: 1px solid #0A0D0F;
        padding: 21px 46px;
        background: transparent;
        font-size: 20px;
        font-family: 'SourceHanSansCN Microsoft YaHei';
        font-weight: 400;
        color: #0A0D0F;
        line-height: 24px;
      }


    }
  }
}

</style>